import React from 'react';
import { motion } from 'framer-motion';

interface VersionPreviewBannerProps {
    versionNumber: number;
    onRestore: () => void;
    onClose: () => void;
    isRestoring?: boolean;
}

const VersionPreviewBanner: React.FC<VersionPreviewBannerProps> = ({
    versionNumber,
    onRestore,
    onClose,
    isRestoring = false
}) => {
    return (
        <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed top-0 left-0 right-0 z-50 bg-mcdm-third-500 dark:bg-mcdm-primary-200 text-white shadow-lg"
        >
            <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <span className="font-medium">
                        Prévisualisation de la version {versionNumber}
                    </span>
                    <span className="text-mcdm-primary-500 text-sm">
                        (lecture seule)
                    </span>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        onClick={onRestore}
                        disabled={isRestoring}
                        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
                            isRestoring
                                ? 'bg-mcdm-green-500 cursor-wait'
                                : 'bg-white text-mcdm-green-300 hover:bg-mcdm-green-400 hover:text-mcdm-primary-100'
                        }`}
                    >
                        {isRestoring ? 'Restauration...' : 'Restaurer cette version'}
                    </button>
                    <button
                        onClick={onClose}
                        disabled={isRestoring}
                        className="px-4 py-1.5 text-sm font-medium rounded-md border border-white/50 hover:bg-mcdm-secondary-200 transition-colors"
                    >
                        Fermer
                    </button>
                </div>
            </div>
        </motion.div>
    );
};

export default VersionPreviewBanner;
